module.exports = __webpack_public_path__ + "static/media/starMap.898a061a.jpg";